import searchQuery from './search.query'

export default {
  register(eventContext) {
    ;[searchQuery].forEach(callback => {
      callback(eventContext)
    })
  },
}
